import { useForm } from '@mantine/form';
import { useState } from 'react';
import { validateText } from '../../../util/validation/commonValidation';
import type { GroupDto } from '../types/GroupDto';

const defaultGroup: GroupDto = {
	groupName: '',
	id: ''
};

export function useUpsertGroupForm(group: GroupDto = defaultGroup) {
	const [inputs, setInputs] = useState<GroupDto>(group);

	const form = useForm<GroupDto>({
		mode: 'uncontrolled',
		initialValues: group,
		validate: {
			groupName: (value) => validateText(value, false, "Group name", 40),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}